export default {
  title: 'DRIVER BAD RATING NOTIFICATION', 
  items: {
    BadReviewEmail: {
      label: 'Emails to Notify',
      type: 'string',
      unit: 'email (comma-separated)'
    },
    BadReviewSms: {
      label: 'Phone Numbers To Notify',
      type: 'string',
      unit: 'phone (comma-separated)'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/driver-bad-rating-notification.js